import React from 'react';
import { PropTypes } from 'prop-types';

import Text, { TextTypes } from '../../Text';

import ProcessSlide from '../ProcessSlide';
import NextSlideButton from '../NextSlideButton';
import StepNavigation from '../StepNavigation';

import { CarouselThemes } from '../../../custom-cursor/consts';

import { CarouselTypes } from '../consts';

const ProcessContent = ({
    styles,
    rules,
    slides,
    width,
    activeIndex,
    moveToNextSlideMobile,
    moveToNextSlide,
    title,
    handleHover,
}) => {
    const handleMobileNextSlide = React.useCallback(
        e => {
            e.stopPropagation();
            moveToNextSlideMobile();
        },
        [moveToNextSlideMobile],
    );

    return (
        <>
            <Text as="h2" type={TextTypes.SECTION} extend={rules.extendText}>
                {title}
            </Text>
            <StepNavigation
                type={CarouselTypes.PROCESS}
                slides={slides}
                nextSlide={moveToNextSlide}
                currentSlide={activeIndex}
                isLarge
                handleHover={handleHover}
            />
            <div className={styles.container}>
                {slides.map(slide => (
                    <ProcessSlide
                        key={slide.id}
                        width={width}
                        title={slide.title}
                        description={slide.description}
                        list={slide.list}
                    />
                ))}
            </div>

            <NextSlideButton
                carouselTheme={CarouselThemes.DARK}
                extend={rules.extendButton}
                onClick={handleMobileNextSlide}
            />
        </>
    );
};

ProcessContent.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
    rules: PropTypes.shape().isRequired,
    slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    width: PropTypes.number.isRequired,
    activeIndex: PropTypes.number.isRequired,
    moveToNextSlideMobile: PropTypes.func.isRequired,
    moveToNextSlide: PropTypes.func.isRequired,
    title: PropTypes.node.isRequired,
    handleHover: PropTypes.func,
};

ProcessContent.defaultProps = {
    handleHover: null,
};

export default ProcessContent;
